import { useMemo, useState, useCallback } from 'react';
import { clsx } from 'js/utils/classNames.util';
import { ANIMATION_ITEMS_LIST, ANIMATION_CLASSES_MAP, ANIMATION_ITEMS_CONFIG } from '../config';

export const useAddAnimationClasses = (
    animationClassSuffix = '--animate-on-open',
    shouldAddAnimationClasses = true
) => {
    const [currentClassesMap, setCurrentClassesMap] = useState<{ [key: string]: string[] }>(
        ANIMATION_ITEMS_LIST.reduce(
            (acc, key) => ({
                ...acc,
                [key]: ANIMATION_CLASSES_MAP[key].map((cn: string) => ANIMATION_ITEMS_CONFIG[key].style[cn])
            }),
        {})
    );

    const handleSetClasses = useCallback((key: string) => setCurrentClassesMap(prev => ({
        ...prev,
        [key]: [clsx([
            ...shouldAddAnimationClasses
                ? ANIMATION_CLASSES_MAP[key].map(
                    cn => {
                        return ANIMATION_ITEMS_CONFIG[key].style[`${cn}${ANIMATION_ITEMS_CONFIG[key].classNameSuffix || ''}${animationClassSuffix}`];
                    }
                ) : []
        ])]
    })), [animationClassSuffix, shouldAddAnimationClasses]);

    const handleSetClassesMap: { [key: string]: () => void } = useMemo(
        () => ANIMATION_ITEMS_LIST.reduce((acc, key) => ({
            ...acc,
            [key]: () => handleSetClasses(key as string)
        }),
        {}),
        [handleSetClasses]
    );

    const handleToRemoveClasses = useCallback((key: string) => {
        setCurrentClassesMap(prev => ({
            ...prev,
            [key]: prev[key].map(
                (classNames: string = '') =>
                    classNames.split(' ')
                    .filter(el => !el.includes(animationClassSuffix))
                    .join()
            )
        }));
    }, [animationClassSuffix]);

    const handleToRemoveClassesMap: { [key: string]: () => void } = useMemo(
        () => ANIMATION_ITEMS_LIST.reduce((acc, key) => ({
            ...acc,
            [key]: () => handleToRemoveClasses(key as string)
        }),
        {}),
        [handleToRemoveClasses]
    );

    return {
        currentClassesMap,
        handleToRemoveClassesMap,
        handleSetClassesMap
    };
};
